<template>
  <div class="secondh">
    <div class="secondh-t">
      <div class="layer">
        <el-row class="header">
          <el-col :span="6">
            <a href=""><img class="logo" src="static/img/logo.png"></a>
          </el-col>
          <el-col :span="12"><div class="grid-content"></div></el-col>
          <el-col :span="6">
            <ul class="nav clearfix">
              <li><a href="">登录</a></li>
              <li><a href="">数据说明</a></li>
              <li><a href="">帮助</a></li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="secondh-b">
      <div class="layer clearfix">
        <div class="kgo-logo">
          <div>
            <img src="static/img/kgo-logo.png" alt="">
          </div>
          <p class="subcenter-title">中国工程科技专家库</p>
        </div>
        <div class="kgo-search">
          <div class="search-input-body">
            <input class="s-input" type="text" name="" id="" placeholder="请输入研究关键词（更多查询条件请使用高级搜索）">
            <button class="s-btn"><i class="magnifier-ico"></i>搜索</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.secondh{
  width: 100%;
  height: 276px;
  background: url(../../../static/img/header.png)no-repeat;
  background-size: cover !important;
}
.secondh-t{
  border-bottom: 1px solid #dbdbdb;
  .header{
    margin-bottom: 20px;
  }
}
.secondh-b{
  padding-top: 40px;
}
.kgo-logo{
  float: left;
  margin-left: 118px;
  text-align: right;
  margin-top: 0;
  margin-right: 20px;
}
.kgo-search{
  float: left;
}
.subcenter-title {
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.search-input-body {
  position: relative;
  width: 739px;
  padding: 0;
  border-radius: 6px;
  border: 3px solid #CED8F9;
}
.s-input {
  width: 100%;
  line-height: 28px;
  font-size: 17px;
  padding: 13px 10px 11px 13px;
  border: 0;
  color: #333;
  border-radius: 3px 0 0 3px;
  background: rgba(255,255,255,.2);
}
.s-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: 108px;
  height: 53px;
  border: 0;
  color: #fff;
  font-size: 18px;
  background: #2593c5;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
}
.magnifier-ico {
    position: relative;
    top: 2px;
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../../../static/img/icon/icon-set.png) no-repeat -70px 0;
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SecondaryHeader.vue